import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Paper,
  TextField,
  IconButton,
  Link,
} from "@mui/material";
import { styled } from "@mui/system";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import clipboardCopy from "clipboard-copy";
import AOS from "aos";
import "aos/dist/aos.css";
import rdxLogo from "../assets/rdxlogo.png";
import ParticlesBg from "particles-bg";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link as ScrollLink } from "react-scroll";
import { CssBaseline } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import CountUp from "react-countup";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { Email, Twitter, Telegram } from "@mui/icons-material";
import { Avatar } from "@mui/material";
import viduraImage from "../assets/vidura.png";
import farahImage from "../assets/pfp_nobg.jpg";
import akilaImage from "../assets/akila.png";
import dogImage from "../assets/dog.jpg";
import { Drawer, Hidden } from "@mui/material";


AOS.init();

const HeroTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: 600,
  letterSpacing: "2px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));
const AnimatedTextNoCursor = ({ text, delay }) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setDisplayedText((prev) => prev + text[index]);
      index++;
      if (index === text.length) {
        clearInterval(interval);
      }
    }, delay);

    return () => clearInterval(interval);
  }, [text, delay]);

  return <>{displayedText}</>;
};

const AnimatedText = ({ text, delay, showCursor = true }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setDisplayedText((prev) => prev + text[index]);
      index++;

      if (index === text.length) {
        clearInterval(interval);
        setTimeout(() => setIsTyping(false), 500);
      }
    }, delay);

    return () => clearInterval(interval);
  }, [text, delay]);

  return (
    <>
      {displayedText}
      {showCursor && isTyping && (
        <span
          style={{
            display: "inline-block",
            verticalAlign: "bottom",
            animation: "1s blink step-end infinite",
            borderLeft: "10px solid #17252A", // Adjust the border-left property to make the cursor thicker
          }}
        >
          &nbsp;
        </span>
      )}
    </>
  );
};

const HomePage = () => {
  const validatorAddress =
    "rv1qvd3gl3eh4gec0q26lke050z0g7xexphrexqkwg8l926l0a2w7skg29urcg";
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (text) => {
    try {
      await clipboardCopy(text);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy text: ", error);
    }
  };
  const theme = createTheme();
  const responsiveTheme = responsiveFontSizes(theme);

  const [activeSection, setActiveSection] = useState(null);

  const [drawerOpen, setDrawerOpen] = useState(false);

const handleDrawerToggle = () => {
  setDrawerOpen(!drawerOpen);
};

const HamburgerIcon = ({ onClick }) => (
  <div onClick={onClick} style={{ cursor: "pointer" }}>
    <div style={{ width: "30px", height: "4px", backgroundColor: "#fff", marginBottom: "5px" }} />
    <div style={{ width: "30px", height: "4px", backgroundColor: "#fff", marginBottom: "5px" }} />
    <div style={{ width: "30px", height: "4px", backgroundColor: "#fff" }} />
  </div>
);

  useEffect(() => {
    const handleScroll = () => {
      const sectionIds = [
        "whyus-section",
        "serverspecs-section",
        "ourteam-section",
        "fees-section",
        "contact-section",
      ];
      const currentSection = sectionIds.find((id) => {
        const section = document.getElementById(id);
        if (section) {
          return (
            window.scrollY >= section.offsetTop - 70 &&
            window.scrollY < section.offsetTop + section.offsetHeight - 70
          );
        }
        return false;
      });
      setActiveSection(currentSection);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [isSticky, setSticky] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
<Box sx={{ overflowX: 'hidden' }}>
      <CssBaseline />
      {/* Header */}
      <Box
        component="header"
        sx={{
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 999,
          backgroundColor: "#17252A",
          opacity: isSticky ? 1 : 1,  // fades in when sticky
          transition: "opacity 0.3s ease",
        }}
      >
        <Container maxWidth="1200px" sx={{ paddingLeft: 1, height: "80px" }}>
          <AppBar position="sticky" color="transparent" elevation={0}>
            <Toolbar disableGutters sx={{ height: "80px" }}>
            <Typography
  variant="h4"
  color="white"
  sx={{
    fontWeight: 900,
    fontFamily: "'Gruppo', cursive",
    fontSize: {
      xs: "28px",
      sm: "32px",
      md: "48px",
      lg: "48px",
      xl: "64px",
      "2xl": "64px",
    },
  }}
  component={responsiveTheme.components.h4}
>
  <img
    src={rdxLogo}
    alt="RDXnodeGuard Icon"
    style={{
      height: "64px",
      marginLeft: "-16px",
      marginRight: "8px",
      verticalAlign: "middle",
    }}
  />
  RDXnodeGuard
</Typography>

              <Box sx={{ flexGrow: 1 }} />
              <Hidden mdUp>
                <HamburgerIcon onClick={handleDrawerToggle} />
              </Hidden>
              <Hidden smDown>
              <Box
                sx={{
                  display: "flex",
                  backgroundColor: "#1A2D33",
                  padding: "8px",
                  borderRadius: "10px",
                }}
              />
              <ScrollLink
                activeClass="active"
                to="whyus-section"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                style={{ marginRight: 30, cursor: "pointer" }}
                className={activeSection === "whyus-section" ? "active" : ""}
              >
                <Typography
                  variant="subtitle1"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "25px",
                    fontFamily: "'Gruppo', cursive",
                  }}
                >
                  Why Us?
                </Typography>
              </ScrollLink>
              <ScrollLink
                activeClass="active"
                to="serverspecs-section"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                style={{ marginRight: 30, cursor: "pointer" }}
                className={
                  activeSection === "serverspecs-section" ? "active" : ""
                }
              >
                <Typography
                  variant="subtitle1"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "25px",
                    fontFamily: "'Gruppo', cursive",
                  }}
                >
                  Server Specs
                </Typography>
              </ScrollLink>
              <ScrollLink
                activeClass="active"
                to="ourteam-section"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                style={{ marginRight: 30, cursor: "pointer" }}
                className={activeSection === "ourteam-section" ? "active" : ""}
              >
                <Typography
                  variant="subtitle1"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "25px",
                    fontFamily: "'Gruppo', cursive",
                  }}
                >
                  Our Team
                </Typography>
              </ScrollLink>
              <ScrollLink
                activeClass="active"
                to="fees-section"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                style={{ marginRight: 30, cursor: "pointer" }}
                className={activeSection === "fees-section" ? "active" : ""}
              >
                <Typography
                  variant="subtitle1"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "25px",
                    fontFamily: "'Gruppo', cursive",
                  }}
                >
                  Fees 
                </Typography>
              </ScrollLink>
              <ScrollLink
                activeClass="active"
                to="contact-section"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                style={{  cursor: "pointer" }}
                className={activeSection === "contact-section" ? "active" : ""}
              >
                <Typography
                  variant="subtitle1"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "25px",
                    fontFamily: "'Gruppo', cursive",
                  }}
                >
                  Contact
                </Typography>
              </ScrollLink>
              </Hidden>
            </Toolbar>
          </AppBar>
        </Container>
        <Hidden mdUp>
  <Drawer
    anchor="left"
    open={drawerOpen}
    onClose={handleDrawerToggle}
    sx={{
      "& .MuiDrawer-paper": {
        backgroundColor: "#17252A",
        width: "250px",
      },
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "16px",
      }}
    >
      <ScrollLink
        activeClass="active"
        to="whyus-section"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
        style={{ marginBottom: "16px", cursor: "pointer" }}
        className={activeSection === "whyus-section" ? "active" : ""}
        onClick={handleDrawerToggle}
      >
        <Typography
          variant="subtitle1"
          color="white"
          sx={{
            fontWeight: "bold",
            fontSize: "25px",
            fontFamily: "'Gruppo', cursive",
          }}
        >
          Why Us?
        </Typography>
      </ScrollLink>
      <ScrollLink
        activeClass="active"
        to="serverspecs-section"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
        style={{ marginBottom: "16px" ,  cursor: "pointer"}}
        className={activeSection === "serverspecs-section" ? "active" : ""}
        onClick={handleDrawerToggle}
      >
        <Typography
          variant="subtitle1"
          color="white"
          sx={{
            fontWeight: "bold",
            fontSize: "25px",
            fontFamily: "'Gruppo', cursive",
          }}
        >
          Server Specs
        </Typography>
      </ScrollLink>
      <ScrollLink
        activeClass="active"
        to="ourteam-section"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
        style={{ marginBottom: "16px" ,  cursor: "pointer"}}
        className={activeSection === "ourteam-section" ? "active" : ""}
        onClick={handleDrawerToggle}
      >
        <Typography
          variant="subtitle1"
          color="white"
          sx={{
            fontWeight: "bold",
            fontSize: "25px",
            fontFamily: "'Gruppo', cursive",
          }}
        >
          Our Team
        </Typography>
      </ScrollLink>
      <ScrollLink
        activeClass="active"
        to="fees-section"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
        style={{ marginBottom: "16px",  cursor: "pointer" }}
        className={activeSection === "fees-section" ? "active" : ""}
        onClick={handleDrawerToggle}
      >
        <Typography
          variant="subtitle1"
          color="white"
          sx={{
            fontWeight: "bold",
            fontSize: "25px",
            fontFamily: "'Gruppo', cursive",
          }}
        >
          Fees
        </Typography>
      </ScrollLink>
      <ScrollLink
        activeClass="active"
        to="contact-section"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
        style={{ marginBottom:'0px', cursor: "pointer"}}
        className={activeSection === "contact-section" ? "active" : ""}
        onClick={handleDrawerToggle}
      >
        <Typography
          variant="subtitle1"
          color="white"
          sx={{
            fontWeight: "bold",
            fontSize: "25px",
            fontFamily: "'Gruppo', cursive",
          }}
        >
          Contact
        </Typography>
      </ScrollLink>
    </Box>
  </Drawer>
</Hidden>

      </Box>
      {/* Placeholder box */}
      <Box
        sx={{
          height: "80px",  // matches the height of the header
        }}
      />
      {/* Hero Section */}
      <Box
        component="section"
        py={4}
        position="relative"
        sx={{
          background: "linear-gradient(180deg, #257A78 0%, #17252A 100%)",
          zIndex: 1,
        }}
      >
        <Container maxWidth="md">
  <HeroTypography
    variant="h3"
    color="white"
    textAlign="center"
    data-aos="zoom-in"
    data-aos-duration="800"
    sx={{
      fontFamily: "'Podkova', serif;",
      fontSize: {
        xs: "48px",
        sm: "64px",
      },
    }}
  >
    Welcome to{" "}
    <AnimatedText
      text="RDXnodeGuard"
      delay={100}
      sx={{ fontWeight: "100px" }}
    />
  </HeroTypography>
  <Typography
    variant="h6"
    color="white"
    textAlign="center"
    mt={2}
    data-aos="fade-up"
    data-aos-delay="400"
    sx={{
      fontFamily: "'Podkova', serif",
      fontSize: {
        xs: "18px",
        sm: "28px",
      },
    }}
  >
   Your stake is our responsibility!
  </Typography>
  <Grid container justifyContent="center">
    <Grid item>
      <Box textAlign="center" mt={4} sx={{ zIndex: 2 }}>
        <TextField
          value={validatorAddress}
          InputProps={{
            readOnly: true,
            sx: {
              fontWeight: "bold",
              height: "38px",
              width: "100%",
              backgroundColor: "#F2F2F2",
              "&:hover": {
                backgroundColor: "#E0E0E0",
              },
              "@media (min-width: 600px)": {
                minWidth: "500px",
              },
              "@media (max-width: 599px)": {
                minWidth: "300px",
              },
            },
            endAdornment: (
              <IconButton
                edge="end"
                color="inherit"
                sx={{
                  color: isCopied ? "#1F2833" : "#3AAFA9",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                onClick={() => copyToClipboard(validatorAddress)}
              >
                <FileCopyIcon />
              </IconButton>
            ),
          }}
          fullWidth
          variant="outlined"
        />
      </Box>
    </Grid>
  </Grid>
</Container>

        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          zIndex={-1} // Set a lower zIndex value
        >
          <ParticlesBg type="cobweb" num={70} color="#9DACB2" />
        </Box>
      </Box>
      {/* Why Us Section */}
      <Box
        component="section"
        py={6}
        id="whyus-section"
        bgcolor="#DEF2F1"
        data-aos="fade-up"
        data-aos-delay="500"
      >
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 2, sm: 2, md: 2 }}>
            <Grid item xs={12} md={5}>
              <Typography
                variant="h4"
                color="#17252A"
                sx={{
                  fontWeight: 700,
                  fontSize: "70px",
                  fontFamily: "'Podkova', serif;",
                  marginLeft: 10,
                }}
                data-aos="slide-right"
                data-aos-duration="2000"
              >
                ABOUT US
              </Typography>
              <Typography
                variant="h6"
                color="grey.700"
                sx={{
                  fontWeight: 400,
                  fontFamily: "'Podkova', serif",
                  marginLeft: 10,
                  fontSize: "25px",
                }}
                data-aos="slide-right"
                data-aos-duration="2000"
              >
                Why choose RDXNodeGuard?
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Grid item xs={12} md={12}>
                <Box>
                  <Box
                    sx={{
                      borderLeft: "3px solid #2B7A78",
                      pl: 2,
                    }}
                    data-aos="slide-left"
                    data-aos-duration="2000"
                  >
                    <Typography
                      variant="h6"
                      color="#17252A"
                      sx={{
                        fontWeight: 200,
                        fontFamily: "'Podkova', serif;",
                        fontSize: "20px",
                        ml: 3,
                      }}
                      data-aos="slide-left"
                      data-aos-duration="2000"
                    >
                      RDXNodeGuard, a US-based node operator, is managed by a
                      team of seasoned security professionals and Linux
                      administrators devoted to supporting the Radix platform.
                      Our mission is to contribute to the Radix ecosystem by
                      offering top-notch, transparent, and reliable service to
                      our valued delegators.
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Box mt={4} ml={{ xs: 1, sm: 2, md: 14 }}>
            <Typography
              variant="h6"
              color="grey.700"
              sx={{
                fontWeight: 400,
                fontFamily: "'Podkova', serif",
                fontSize: "20px",
              }}
            >
              <ul>
                <li>
                  Servers built and maintained according to{" "}
                  <span
                    style={{
                      color: "#17252A",
                      fontWeight: 700,
                      fontFamily: "'Podkova', serif",
                      fontSize: "20px",
                    }}
                  >
                    industry hardening standards like CIS benchmarks
                  </span>
                </li>
                <li>
                  {" "}
                  <span
                    style={{
                      color: "#17252A",
                      fontWeight: 700,
                      fontFamily: "'Podkova', serif",
                      fontSize: "20px",
                    }}
                  >
                    Checked against 80% PCI DSS{" "}
                  </span>{" "}
                  used in the payment card industry
                </li>
                <li>
                  Team consists of security specialists and Linux administrators
                  with{" "}
                  <span
                    style={{
                      color: "#17252A",
                      fontWeight: 700,
                      fontFamily: "'Podkova', serif",
                      fontSize: "20px",
                    }}
                  >
                    collectively 15 years of experience{" "}
                  </span>
                </li>
                <li>
                  We believe in the future of Radix and decentralization, so we
                  are here to stay
                </li>
                <li>
                  <span
                    style={{
                      color: "#17252A",
                      fontWeight: 700,
                      fontFamily: "'Podkova', serif",
                      fontSize: "20px",
                    }}
                  >
                    Servers are vertically scalable,
                  </span>{" "}
                  so we can handle anything that gets thrown our way
                </li>
                <li>
                  <span
                    style={{
                      color: "#17252A",
                      fontWeight: 700,
                      fontFamily: "'Podkova', serif",
                      fontSize: "20px",
                    }}
                  >
                    Main server and backups are located in separate regions and
                    separate providers,
                  </span>{" "}
                  to maximize availability
                </li>
                <li>
                  <span
                    style={{
                      color: "#17252A",
                      fontWeight: 700,
                      fontFamily: "'Podkova', serif",
                      fontSize: "20px",
                    }}
                  >
                    Main server is backed up with GCP Cloud Armor,
                  </span>{" "}
                  so no DDoS even at layer 7
                </li>
              </ul>
            </Typography>
          </Box>
        </Container>
      </Box>
      {/* Server Specs Section */}
      <Box
        component="section"
        py={8}
        id="serverspecs-section"
        bgcolor="#C6F2F0"
        data-aos="fade-in"
        data-aos-delay="400"
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            color="#17252A"
            sx={{
              fontWeight: 700,
              fontSize: "65px",
              fontFamily: "'Podkova', serif;",
              textAlign: "center",
              mb: 4,
            }}
            data-aos="fade-in"
            data-aos-duration="1000"
          >
            OUR SERVERS
          </Typography>
          <Grid container justifyContent="center" spacing={4}>
            <Grid item xs={12} sm={3}>
              <Typography
                variant="h4"
                color="#17252A"
                sx={{
                  fontWeight: 700,
                  fontFamily: "'Podkova', serif",
                  textAlign: "center",
                  fontSize: "50px",
                  mb: 1,
                }}
              >
                <CountUp start={0} end={99.99} decimals={2} duration={8} />%
              </Typography>
              <Typography
                variant="h6"
                color="grey.700"
                sx={{
                  fontWeight: 450,
                  fontFamily: "'Podkova', serif",
                  textAlign: "center",
                  fontSize: "28px",
                }}
              >
                Uptime
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography
                variant="h4"
                color="#17252A"
                sx={{
                  fontWeight: 700,
                  fontFamily: "'Podkova', serif",
                  textAlign: "center",
                  fontSize: "50px",
                  mb: 1,
                }}
              >
                <CountUp start={0} end={8} duration={10} />+
              </Typography>
              <Typography
                variant="h6"
                color="grey.700"
                sx={{
                  fontWeight: 450,
                  fontFamily: "'Podkova', serif",
                  textAlign: "center",
                  fontSize: "28px",
                }}
              >
                CPUs
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography
                variant="h4"
                color="#17252A"
                sx={{
                  fontWeight: 700,
                  fontFamily: "'Podkova', serif",
                  textAlign: "center",
                  fontSize: "50px",
                  mb: 1,
                }}
              >
                <CountUp start={0} end={16} duration={10} />
                GB+
              </Typography>
              <Typography
                variant="h6"
                color="grey.700"
                sx={{
                  fontWeight: 450,
                  fontFamily: "'Podkova', serif",
                  textAlign: "center",
                  fontSize: "28px",
                }}
              >
                Memory
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography
                variant="h4"
                color="#17252A"
                sx={{
                  fontWeight: 700,
                  fontFamily: "'Podkova', serif",
                  textAlign: "center",
                  fontSize: "50px",
                  mb: 1,
                }}
              >
                <CountUp start={0} end={350} duration={8} />
                GB SSD
              </Typography>
              <Typography
                variant="h6"
                color="grey.700"
                sx={{
                  fontWeight: 450,
                  fontFamily: "'Podkova', serif",
                  textAlign: "center",
                  fontSize: "28px",
                }}
              >
                Storage
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* Our team section */}
      <Box
        component="section"
        py={6}
        id="ourteam-section"
        bgcolor="#F6F9FB"
        data-aos="fade-up"
        data-aos-delay="500"
        sx={{ bgcolor: "#DEF2F1" }}
      >
        <Container maxWidth="xl">
          <Typography
            variant="h4"
            color="#17252A"
            sx={{
              fontWeight: 700,
              fontSize: "65px",
              fontFamily: "'Podkova', serif;",
              textAlign: "center",
              mb: 7,
            }}
            data-aos="fade-in"
            data-aos-duration="750"
          >
            MEET THE TEAM
          </Typography>
          <Grid container spacing={4} justifyContent="center">
  <Grid item xs={6} md={3}>
    <Box textAlign="center">
      <Box
        sx={{
          width: 150,
          height: 150,
          borderRadius: "50%",
          border: "4px solid #2B7A78",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 2,
          marginLeft: "auto",
          marginRight: "auto",
          transition: "border-color 0.3s, transform 0.3s",
          "&:hover": {
            borderColor: "#3AAFA9",
            borderWidth: "8px",
            cursor: "pointer",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.4)",
            transform: "scale(1.05)",
          },
        }}
        onClick={() => {
          window.open(
            "https://www.linkedin.com/in/vidura-supun/",
            "_blank"
          );
        }}
      >
        <Avatar
          alt="Vidura"
          src={viduraImage}
          sx={{ width: 140, height: 140 }}
        />
      </Box>
      <Typography
        variant="h5"
        mt={2}
        fontWeight={700}
        fontFamily={"'Podkova', serif"}
        sx={{
          fontSize: { xs: 20, md: 24 },
          lineHeight: 1.2,
        }}
      >
        Vidura Ehalapitiya
      </Typography>
      <Typography
        variant="subtitle1"
        fontSize={17}
        color="grey.800"
        sx={{
          marginTop: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: { xs: 14, md: 17 },
        }}
        fontFamily={"'Podkova', serif"}
      >
        Cyber Security Specialist
      </Typography>
    </Box>
  </Grid>
  <Grid item xs={6} md={3}>
    <Box textAlign="center">
      <Box
        sx={{
          width: 150,
          height: 150,
          borderRadius: "50%",
          border: "4px solid #2B7A78",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 2,
          marginLeft: "auto",
          marginRight: "auto",
          transition: "border-color 0.3s, transform 0.3s",
          "&:hover": {
            borderColor: "#3AAFA9",
            borderWidth: "8px",
            cursor: "pointer",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.4)",
            transform: "scale(1.05)",
          },
        }}
        onClick={() => {
          window.open(
            "https://www.linkedin.com/in/farahw/",
            "_blank"
          );
        }}
      >
        <Avatar
          alt="PFP"
          src={farahImage}
          sx={{ width: 140, height: 140 }}
        />
      </Box>
      <Typography
        variant="h5"
        mt={2}
        fontWeight={700}
        fontFamily={"'Podkova', serif"}
        sx={{
          fontSize: { xs: 20, md: 24 },
          lineHeight: 1.2,
        }}
      >
        Farah Warnakulasuriya
      </Typography>
      <Typography
        variant="subtitle1"
        fontFamily={"'Podkova', serif"}
        fontSize={17}
        color="grey.800"
        sx={{
          marginTop: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: { xs: 14, md: 17 },
        }}
      >
        Senior DevOps Engineer
      </Typography>
    </Box>
  </Grid>
  <Grid item xs={6} md={3}>
    <Box textAlign="center">
      <Box
        sx={{
          width: 150,
          height: 150,
          borderRadius: "50%",
          border: "4px solid #2B7A78",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 2,
          marginLeft: "auto",
          marginRight: "auto",
          transition: "border-color 0.3s, transform 0.3s",
          "&:hover": {
            borderColor: "#3AAFA9",
            borderWidth: "8px",
            cursor: "pointer",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.4)",
            transform: "scale(1.05)",
          },
        }}
        onClick={() => {
          window.open(
            "https://www.linkedin.com/in/aprabash1/",
            "_blank"
          );
        }}
      >
        <Avatar
          alt="Akila"
          src={akilaImage}
          sx={{ width: 140, height: 140 }}
          fontFamily={"'Podkova', serif"}
        />
      </Box>
      <Typography
        variant="h5"
        mt={2}
        fontWeight={700}
        fontFamily={"'Podkova', serif"}
        sx={{
          fontSize: { xs: 20, md: 24 },
          lineHeight: 1.2,
        }}
      >
        Akila Bandara
      </Typography>
      <Typography
        variant="subtitle1"
        fontSize={17}
        color="grey.800"
        fontFamily={"'Podkova', serif"}
        sx={{
          marginTop: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: { xs: 14, md: 17 },
        }}
      >
        Cloud and System Administrator
      </Typography>
    </Box>
  </Grid>
  <Grid item xs={6} md={3}>
    <Box textAlign="center">
      <Box
        sx={{
          width: 150,
          height: 150,
          borderRadius: "50%",
          border: "4px solid #2B7A78",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 2,
          marginLeft: "auto",
          marginRight: "auto",
          //     transition: "border-color 0.3s, transform 0.3s",
          //     "&:hover": {
          //       borderColor: "#FF6F61",
          //       borderWidth: "8px",
          //       cursor: "pointer",
          //       boxShadow: "0 0 10px rgba(0, 0, 0, 0.4)",
          //       transform: "scale(1.05)",
          //     },
          //   }}

          //   onClick={() => {
          //     window.location.href = "https://www.linkedin.com/dog";
        }}
      >
        <Avatar
          alt="Dog"
          src={dogImage}
          sx={{ width: 140, height: 140 }}
        />
      </Box>
      <Typography
        variant="h5"
        mt={2}
        fontWeight={700}
        fontFamily={"'Podkova', serif"}
        sx={{
          fontSize: { xs: 20, md: 24 },
          lineHeight: 1.2,
        }}
      >
        Zoe
      </Typography>
      <Typography
        variant="subtitle1"
        fontSize={17}
        color="grey.800"
        sx={{
          marginTop: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: { xs: 14, md: 17 },
        }}
        fontFamily={"'Podkova', serif"}
      >
        Head of Pup-lic Relations
      </Typography>
    </Box>
  </Grid>
</Grid>

 
        </Container>
      </Box>
      {/* Fees Section */}
      <Box
  component="section"
  py={6}
  id="fees-section"
  bgcolor="#C6F2F0"
  data-aos="fade-up"
  data-aos-delay="500"
>
  <Container maxWidth="lg">
    <Grid container spacing={{ xs: 2, sm: 2, md: 2 }}>
      <Grid item xs={12} md={5}>
        <Typography
          variant="h4"
          color="#17252A"
          sx={{
            fontWeight: 700,
            fontSize: "70px",
            fontFamily: "'Podkova', serif;",
            textAlign: "left",
            marginLeft: 10,
          }}
          data-aos="slide-right"
          data-aos-duration="2000"
        >
          1.75%
        </Typography>
        <Typography
          variant="h6"
          color="grey.700"
          sx={{
            fontWeight: 400,
            fontFamily: "'Podkova', serif",
            fontSize: "25px",
            textAlign: "left",
            marginLeft: 10,
          }}
          data-aos="slide-right"
          data-aos-duration="2000"
        >
          Competitive and Transparent Fees
        </Typography>
      </Grid>
      <Grid item xs={12} md={7}>
        <Box
          sx={{
            borderLeft: "3px solid #2B7A78",
            pl: 2,
          }}
          data-aos="slide-left"
          data-aos-duration="2000"
        >
          <Typography
            variant="h6"
            color="#17252A"
            sx={{
              fontWeight: 200,
              fontFamily: "'Podkova', serif;",
              fontSize: "20px",
              ml: 3,
            }}
            data-aos="slide-left"
            data-aos-duration="2000"
          >
            Our fee structure is simple and transparent. We charge a flat 
            <span style={{color: '#2B7A78', fontWeight: 700}}> 1.75% </span> 
            of the rewards earned by our delegators. This fee is used to cover operating expenses and to ensure that our servers are running optimally 24/7. We believe in providing value for money and our competitive fee guarantees that our delegators receive the majority of their rewards.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </Container>
</Box>

{/* Contact Section */}
<Box
  component="section"
  py={6}
  id="contact-section"
  bgcolor="#DEF2F1"
  data-aos="fade-up"
  data-aos-delay="500"
>
  <Container maxWidth="lg">
    <Grid container spacing={{ xs: 2, sm: 2, md: 2 }}>
      <Grid item xs={12} md={12}>
        <Typography
          variant="h4"
          color="#17252A"
          sx={{
            fontWeight: 700,
            fontSize: "50px",
            fontFamily: "'Podkova', serif;",
            textAlign: "center",
          }}
          data-aos="zoom-in"
          data-aos-duration="2000"
        >
          CONTACT US
        </Typography>
        <Typography
          variant="h6"
          color="grey.700"
          sx={{
            fontWeight: 400,
            fontFamily: "'Podkova', serif",
            fontSize: "25px",
            textAlign: "center",
            marginTop: "10px",
          }}
          data-aos="zoom-in"
          data-aos-duration="2000"
        >
          We'd Love to Hear From You
        </Typography>
        <form
          action="https://getform.io/f/b7fa2a94-fcca-4db6-a5b1-0b1c834d4ee6"
          method="POST"
        >
          <Box
            component="div"
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              color="primary"
              name="email"
              required
              sx={{ 
                width: "80%", 
                marginBottom: "10px",
                backgroundColor: '#F6F9FB',
                borderRadius: '5px',
              }}
            />
            <TextField
              id="message"
              label="Message"
              variant="outlined"
              color="primary"
              name="message"
              multiline
              rows={4}
              required
              sx={{ 
                width: "80%", 
                marginBottom: "10px",
                backgroundColor: '#F6F9FB',
                borderRadius: '5px',
              }}
            />
            <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{
                backgroundColor: "#2B7A78",
                marginTop: "10px",
                padding: "10px 30px",
                fontSize: "20px",
                fontWeight: "bold",
                letterSpacing: "1px",
                transition: "0.3s ease",
                '&:hover': {
                  backgroundColor: "#17252A",
                  transform: "translateY(-2px)",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.2)"
                }
              }}
            >
              Send
            </Button>
          </Box>
        </form>
      </Grid>
    </Grid>
  </Container>
</Box>

      {/* Footer */}
      <Box component="footer" bgcolor="#17252A" py={4}>
        <Container maxWidth="1200px">
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} sm={6} sx={{ paddingLeft: 1 }}>
              <Typography
                variant="h6"
                color="white"
                gutterBottom
                fontFamily="'Gruppo', cursive"
                fontSize={25}
                fontWeight={900}
              >
                RDXnodeGuard
              </Typography>
              <Typography
                variant="body2"
                color="white"
                fontFamily="'Gruppo', cursive"
                fontSize={18}
              >
                Secure, reliable, and high-performance node validation services.
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ textAlign: "right", paddingRight: 1 }}
            >
              <Typography
                variant="h6"
                color="white"
                gutterBottom
                fontFamily="'Gruppo', cursive"
                fontSize={25}
                fontWeight={900}
              >
                Connect With Us
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Email sx={{ marginRight: 1, color: "white" }} />
                <Link
                  href="mailto:RDXNodeGuard@pm.me"
                  underline="none"
                  color="white"
                >
                  <Typography
                    variant="body2"
                    color="white"
                    fontFamily="'Gruppo', cursive"
                    fontSize={18}
                  >
                    RDXNodeGuard@pm.me
                  </Typography>
                </Link>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Twitter sx={{ marginRight: 1, color: "white" }} />
                <Link
                  href="https://twitter.com/RDXNodeGuard"
                  underline="none"
                  color="white"
                >
                  <Typography
                    variant="body2"
                    color="white"
                    fontFamily="'Gruppo', cursive"
                    fontSize={18}
                  >
                    @RDXnodeGuard
                  </Typography>
                </Link>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Telegram sx={{ marginRight: 1, color: "white" }} />
                <Link
                  href="https://t.me/RDXnodeGuard"
                  underline="none"
                  color="white"
                >
                  <Typography
                    variant="body2"
                    color="white"
                    fontFamily="'Gruppo', cursive"
                    fontSize={18}
                  >
                    t.me/RDXnodeGuard
                  </Typography>
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default HomePage;
